import axiosInstance from "../api/axiosInstance";
import { CITIES } from "../constants/API_URLs";

export interface CityData {
  name: string;
  state: string;
}

export const addCity = (data: any): Promise<any> => {
  return axiosInstance.post(CITIES, data);
};

export const updateCity = (id: any, data: any): Promise<any> => {
  return axiosInstance.patch(`${CITIES}/${id}`, data);
};

export const getCities = (params: any): Promise<any> => {
  return axiosInstance.get(CITIES, { params });
};

export const getCity = (id: any): Promise<any> => {
  return axiosInstance.get(`${CITIES}/${id}`);
};

export const deleteCity = (id: any): Promise<any> => {
  return axiosInstance.delete(`${CITIES}/${id}`);
};
